import { SyntheticEvent, memo } from 'react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { FormControl } from './form-control'
import { SwitchInput } from './switch'
import { classNames } from '@app/utils/classes'

// switch to use across forms
const SwitchToggleComponent = ({
  onChange,
  checked,
  id,
  title,
  translation,
  disabled,
  titleLabel,
}: {
  title: string
  onChange(e: SyntheticEvent<any>): void
  checked?: boolean
  id: string
  translation?: string
  disabled?: boolean
  titleLabel?: boolean
}) => {
  const { t } = useTranslation(translation ?? 'settings')

  return (
    <div className='flex gap-x-2 place-items-center'>
      <SwitchInput
        onChange={onChange}
        checked={checked}
        id={id}
        disabled={disabled}
      >
        {title}
      </SwitchInput>
      <FormControl
        htmlFor={id}
        className={classNames(
          'text-sm tracking-wide capitalize',
          disabled
            ? 'text-gray-500 dark:text-gray-400'
            : 'text-gray-700 dark:text-gray-200'
        )}
        small={false}
        visible
      >
        {titleLabel ? title : t(checked ? 'enabled' : 'disabled')}
      </FormControl>
    </div>
  )
}

export const SwitchToggle = memo(SwitchToggleComponent)
